import { assign } from "../../helper.js";
import { isNil, isPlainObject } from "es-toolkit";
//#region ../erd-editor-schema/dist/v3/parser/doc.js
var createDoc = () => ({
	tableIds: [],
	relationshipIds: [],
	indexIds: [],
	memoIds: [],
	tableGroupIds: [],
	wordIds: [],
	termIds: [],
	domainIds: []
});
function createAndMergeDoc(json) {
	const doc = createDoc();
	if (!isPlainObject(json) || isNil(json)) return doc;
	const assignArray = assign(Array.isArray, doc, json);
	assignArray("tableIds");
	assignArray("relationshipIds");
	assignArray("indexIds");
	assignArray("memoIds");
	assignArray("tableGroupIds");
	assignArray("wordIds");
	assignArray("termIds");
	assignArray("domainIds");
	return doc;
}
//#endregion
export { createAndMergeDoc };
